import React, { useState, useEffect } from 'react';
import AuthService from '../Services/AuthService';
import { Card, CardBody, CardHeader } from 'reactstrap';

const ValidShelves = ({t}) => {
    const [shelves, setShelves] = useState([]);
    const authService = new AuthService();

    const allShelves = authService.getConfig().shelves || [];
    
    useEffect(() => {
        setShelves(authService.getValidShelves() || []);
    }, [])
    return (
        <Card>
            <CardHeader>Πατάρια</CardHeader>
            <CardBody>
                {
                    allShelves.map((shelf, index) => (
                        <Card key={index} className={shelves.includes(shelf) ? 'mb-2 border-success' : 'mb-2 border-danger'}
                        onClick={() => {
                            const updatedShelves = shelves.includes(shelf)
                                ? shelves.filter(s => s !== shelf)
                                : [...shelves, shelf];
                            setShelves(updatedShelves);
                            authService.setValidShelves(updatedShelves);
                        }}>
                            <CardBody>
                                {shelf}
                            </CardBody>
                        </Card>
                    ))
                }
            </CardBody>
        </Card>
    );
};

export default ValidShelves;